import script from "./TemplateCardView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateCardView.vue?vue&type=script&setup=true&lang=ts"

import "./TemplateCardView.vue?vue&type=style&index=0&id=4887d687&scoped=true&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4887d687"]])

export default __exports__